/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import { css } from '@emotion/react';
export const buttonAutoFocusRingFix = css({
  /**
   * TODO AIFOLLOWUP
   * This is a workaround for programmatic focus from autoFocus not using
   * :focus-visible styling in the modal. (See: ED-18908).
   * Styles taken from packages/design-system/focus-ring/src/focus-ring.tsx
   */
  ':focus': {
    outline: `2px solid ${"var(--ds-border-focused, #2684FF)"}`,
    outlineOffset: "var(--ds-space-025, 2px)"
  }
});